const dictionary = {
  general: {
    logo: 'Sobrancelhas Design',
    abbreviationLogo: 'SD',
    copy: 'Copy',
    notification: {
      error: 'Could not load data.',
      pageNotFound: 'Page not found',
      forbidden: 'You do not have access to this area',
    },
    action: 'Action',
    addNew: 'Add',
    edit: 'Edit',
    alter: 'Change',
    note: 'Note',
    update: 'Update',
    back: 'Back',
  },
  auth: {
    login: 'Login',
    logout: 'Logout',
    connectionFail: 'Unable to log in, please try again later.',
    pageTitle: 'Franchisee Store',
    welcome: 'Welcome to the Franchisee Store.',
    instruction: 'Click the button below to access.',
  },
  menu: {
    apollo: 'New Avant',
    reports: {
      title: 'Reports',
      billing: 'Billing Report',
    },
    midiaKit: {
      title: 'Media Kit',
      preInauguration: 'Pre-Opening',
      inaugurationDay: 'Opening and Daily Routine',
      gifts: 'Gifts',
      campaignsPromotions: 'Campaigns and Promotions',
      socialNetworks: 'Social Networks (Posts)',
    },
    corporateMaterial: {
      title: 'Corporate Material',
      openFranchisee: 'Before Opening Your Franchise',
      layoutFranchisee: 'Franchise Layout',
      operationFranchisee: 'Franchise Operation',
      bulletin: 'Announcements',
      technicalCenter: 'Technical Center',
    },
    videos: {
      title: 'Videos',
      eyebrows: 'Eyebrows',
      eyes: 'Eyes',
      face: 'Face',
      lips: 'Lips',
      oaccs: 'Accessories',
    },
    store: {
      title: 'Store',
      kits: 'Home',
      cart: 'Cart',
      orders: 'My Orders',
      ordersSingle: 'Order Page',
      checkout: 'Checkout',
      orderplaced: '',
      coupons: 'Credits',
    },
    admin: {
      kits: 'Admin - Home',
      orders: 'Admin - Orders',
      promotions: 'Admin - Promotions',
      coupon: 'Admin - Credits',
      financial: 'Admin - Financial',
      wallet: {
        title: 'Admin - Bonus',
        points: 'Add Bonus Points',
        bonus: 'Bonus',
        products: 'Product Registration',
      },
      store: {
        title: 'Kit Listing',
        new: 'Create Kit',
        edit: 'Edit Kit',
        orders: 'Orders',
        order: 'Order Page',
        promotions: 'Promotions',
        financial: 'Financial',
        movements: 'Bonus Entries',
        products: 'Products',
        newPromotion: 'Add Promotion',
        updatePromotion: 'Edit Promotion',
      },
    },
  },
  coupon: {
    create: 'Create credit',
    generateRandomNumber: 'Generate random code',
    addNew: 'Add credit',
    expired: 'Expired',
    neverExpires: 'Never expires',
    table: {
      code: 'Code',
      value: 'Value',
      unit: 'Unit',
      observation: 'Observation',
      expiresAt: 'Expires at',
      createdBy: 'Created by',
      used: 'Used',
      createdAt: 'Created at',
      updatedAt: 'Updated at',
    },
    used: {
      yes: 'Used',
      no: 'Available',
    },
    remove: {
      title: 'Remove credit',
      confirm: 'Are you sure you want to remove this credit?',
      ok: 'Remove',
      cancel: 'Cancel',
    },
    notification: {
      create: {
        success: 'Credit created successfully.',
        error: 'Could not create the credit.',
      },
      remove: {
        success: 'Credit removed successfully.',
        error: 'Could not remove the credit.',
      },
    },
    form: {
      title: 'New credit',
      subtitle: 'Set the code, the value, which unit is allowed to use it and, optionally, an expiration date and an internal note.',
      placeholder: {
        code: 'e.g. WELCOME10',
        value: 'Enter the discount value',
        unit: 'Select a unit',
        expiresAt: 'Leave empty and the credit never expires',
        observation: 'Optional: why this credit was issued',
      },
      message: {
        code: 'Enter a code!',
        value: 'Enter a value!',
      }
    },
  },
  pageHeader: {
    search: 'Search',
    filter: 'Filter',
  },
  home: {
    title: 'Home Page',
  },
  avant: {
    logo: 'Avant',
    new: {
      title: 'New Avant',
      description: 'This is the new Avant',
    },
    download: 'Download',
    license: 'License',
    copy: 'License copied!',
    notification: {
      noLicense: {
        title: 'Available Licenses',
        text: 'We couldn’t find any available license for your user. Make sure you logged in with the unit’s email and try again later.\r\n\r\nIf you have any questions, please contact Support at <a href="mailto:novo_avant@gsd.com.br">novo_avant@gsd.com.br</a>.'
      },
    },
  },
  download: {
    description: 'Description',
    files: 'Files',
    copy: 'Link copied!',
  },
  reports: {
    filters: {
      states: 'All states',
      button: 'Filter',
    },
    charts: {
      typeServiceQuantity: 'Service Type (Quantity)',
      typeServiceValue: 'Service Type (Value)',
      sdMakeUpQuantity: 'SD MAKE•UP (Quantity)',
      sdMakeUpValue: 'SD MAKE•UP (Value)',
      utilizationCombo: 'Utilization: Combo (Quantity)',
      utilizationEpilation: 'Utilization: Epilation (Quantity)',
      utilizationSdRelax: 'Utilization: SD Relax (Quantity)',
      utilizationSdMakeUp: 'Utilization: SD MAKE•UP (Quantity)',
    },
    table: {
      title: 'Service Summary',
      quantity: 'Quantity',
      value: 'Value',
    },
  },
  store: {
    purchaseLimit: {
      available: 'Available in installments: {value}',
      exceeded: 'Over the installment limit: upfront payment only',
      limit: 'Limit for installment purchases {range}: {value}',
      used: 'Already in installments {range}: {value}',
      inCart: 'In cart: {value}',
      cashNotice: 'Upfront purchases have no limit.',
      range: {
        month: 'this month',
        period: 'from {from} to {to}',
        since: 'from {from} on',
      },
      shippingNotice: 'Shipping and insurance do not count toward the limit.',
    },
    add: 'Buy',
    remove: 'Remove',
    view: 'View',
    unavailable: 'Unavailable',
    addNew: 'Add',
    minPrice: 'starting at',
    notifyAvailable: 'Notify me when available',
    types: {
      1: 'Supply',
      2: 'Makeup',
    },
    emptyData: 'No kits found',
    notification: {
      list: {
        error: 'Could not update the kit.',
      },
      notifyMe: {
        success: 'You will be notified when this product becomes available.',
        error: 'Could not schedule the notification',
      }
    },
    search: {
      kits: 'Filter by kit',
      products: 'Search by product',
    },
    blocked: {
      type: 'The cart already contains kits of type “{type}”. Only kits of the same type can be added',
      origin: 'The cart already contains kits from “{origin}”. Only kits from the same origin can be added',
      stock: 'Sold out',
      exclusive: 'Exclusive kits must be unique in the cart',
      promotion: 'Promotional kits can only be added with other promotional kits',
      orderProcessing: 'Existe um pedido em processamento',
    },
    alert: {
      title: 'Attention!',
      message: 'We found an issue in your unit\'s registration.<br>If you have any questions, please contact the Finance department at <a href="mailto:{email}">{email}</a>.',
      retry: 'Try again',
      email: 'financeiro@gsd.com.br',
    },
    notFound: 'No products found for the selected filter.',
    points: {
      calculation: '| from {value} to {previousBalance}',
      model: {
        empty: 'No transactions found',
        title: 'Transactions',
      },
      status: {
        received: 'Received',
        exchange: 'Exchange',
        reversal: 'Reversal',
        canceled: 'Canceled',
        pending: 'Pending',
        deposit: 'Deposit',
        expired: 'Expired',
      },
    },
  },
  orders: {
    order: 'Store ID',
    title: 'My Orders',
    course: 'Training',
    kit: 'Kit',
    trackingNumber: 'Tracking Code',
    noTrackingNumber: 'Unavailable',
    shippingMethod: 'Shipping',
    quantity: 'Quantity',
    comments: 'Remarks',
    price: 'Price',
    discount: 'Discount',
    subtotal: 'Subtotal',
    total: 'Total',
    unit: 'Unit',
    paymentInfo: 'Payment',
    productsSubtotal: 'Products',
    insurance: 'Insurance',
    coupon: 'Credit',
    promotion: 'Promotion',
    goBack: 'Go Back',
    message: 'Please note that, due to the current operational crisis faced by Correios, deliveries through this channel may suffer significant delays, affecting the estimated delivery time informed at the time of purchase.',
    table: {
      title: 'Product List',
      orderedAt: 'Order Date',
      updatedAt: 'Updated At',
      order: '#',
      status: 'Status',
      externalId: 'Order ID',
      total: 'Total',
      subtotal: 'Subtotal',
      product: 'Name',
      items: 'Items',
      unit: 'Unit',
      distribution: 'DC',
      nf: 'Invoice',
      discount: 'Discount',
      goldPoints: 'Gold Points',
      silverPoints: 'Silver Points',
      erpId: 'Order ID'
    },
    modal: {
      title: 'Notice',
      continue: 'Continue',
      cancel: 'Cancel',
      message: 'You already have products in your cart! By purchasing again, all current items will be removed. Do you wish to proceed?'
    },
    rePurchase: 'Buy Again',
    cancelOrder: 'Cancel Order',
    confirmCancel: 'Click to Confirm',
    download: 'Download Labels',
    unavailableDownload: 'Labels Unavailable',
    noBarcode: 'This order has no labels',
    notification: {
      error: 'Unable to load the order',
    },
    alert: {
      title: 'Pre-booking',
      message: 'You must fill in all participant information to confirm your reservation.',
    },
    search: {
      labels: {
        title: 'Search Parameters:',
        button: 'Search',
        order: 'Order',
        unit: 'Unit',
        dateRange: 'Period',
        status: 'Status',
        distribution: 'Distribution Center',
        erpId: 'Order ID'
      },
      order: 'Search by Order Number',
      unit: 'Search by Unit',
      distribution: 'All Centers',
      erpId: 'Search by FoccoErp Number'
    },
    warning: {
      title: 'Warning',
      message: 'This order has not been completed yet.'
    }
  },
  billing: {
    title: 'Payment Information',
    status: {
      expired: 'Overdue',
      paid: 'Paid',
      open: 'Open',
      empty: '-',
    },
    table: {
      installment: 'Installment',
      expiration: 'Due Date',
      status: 'Status',
      price: 'Amount',
      download: 'Download',
      availableDownload: 'Download boleto',
      unavailableDownload: 'Available soon',
    },
  },
  status: {
    error: 'Error',
    canceled: 'Canceled',
    cart: 'Cart',
    processing: 'Processing...',
    payment_pending: 'Awaiting Payment',
    paid: 'Paid',
    preparing: 'Preparing...',
    prepared: 'Prepared',
    sent: 'Sent',
    avant_received: 'Received at Avant',
  },
  dateRanges: {
    today: 'Today',
    thisMonth: 'This month',
    lastMonth: 'Last month',
    sevenDaysAgo: 'Last 7 days',
    thirtyDaysAgo: 'Last 30 days',
  },
  checkout: {
    title: 'Order Summary',
    update: 'Update',
    firstIntroMessage: 'Ready to place your order?',
    secondIntroMessage: 'Let’s check if everything is correct.',
    titleCarriers: 'Shipping options',
    titlePaymentMethods: 'Payment options',
    commentsLabel: 'Comments',
    shippinfInfoLabel: 'Pickup information',
    purchase: 'Complete purchase',
    messageAlertGreeting: 'Dear Customer,',
    messageAlert: 'Please note that due to the current Brazilian logistics scenario, deliveries may experience significant delays, affecting the estimated delivery times at the time of purchase. Since delivery is performed by third-party companies outside the distributor’s direct management, our commitment is to ensure fast and secure dispatch of all orders. However, any delays caused by your chosen logistics option are not the responsibility of the distributor.',
    orderReview: {
      subtotal: 'Subtotal',
      insurance: 'Insurance',
      shipping: 'Shipping',
      discount: 'Discount: {discount}',
      totalDiscount: 'Total discounts',
      promotion: 'Promotion: {title}',
      promotionWithPercentage: 'Promotion: {title} ({percentage}%)',
      otherDiscounts: 'Other discounts',
      coupon: 'Credit {code}',
      removeCoupon: 'Remove credit',
      total: 'Total to pay',
    },
    coupon: {
      label: 'Discount credit',
      placeholder: 'Enter the credit code',
      apply: 'Apply',
      applied: 'Credit {code} applied. {value} off the order total.',
      notification: {
        apply: {
          success: 'Credit applied successfully.',
          error: 'Could not apply the credit.',
        },
        remove: {
          success: 'Credit removed successfully.',
          error: 'Could not remove the credit.',
        },
      },
    },
    notice: 'Please verify that shipping and payment options have been selected to complete the purchase.',
    openMonday: 'Is it open on Mondays?',
    shippingInfoNotice: 'When you choose local pickup, you need to provide us with some important information: Carrier’s business name and CNPJ.',
    deliveryAddress: 'Delivery address:',
    shippingLoading: 'Calculating shipping',
    notification: {
      success: 'Order completed successfully',
      error: 'Unable to complete the order.',
    },
    requiredBaseKit: 'Include Kit: {kitRequired}',
    purchaseLimitExceeded: 'The product amount exceeds your unit installment balance {range} ({available} of {limit}). To complete the order, choose upfront payment.',
    basicProductsKit: 'Basic Products!',
    monthlyInstallments: 'Option',
    orderPlaced: {
      title: 'Thank you!',
      subtitle: 'Order placed successfully.',
      received: 'We have received your order information. Payment slips are being generated and will soon be available in the store. Please check your email.',
      notice: '',
      continueShopping: 'Continue shopping',
      viewOrders: 'View orders',
    },
  },
  admin: {
    store: {
      notification: {
        create: {
          success: 'Kit created successfully.',
          error: 'Failed to create the kit.',
        },
        update: {
          success: 'Kit updated successfully.',
          error: 'Failed to update the kit.',
        },
        labels: {
          success: 'Download completed.',
          error: 'Failed to download the labels.',
        },
        order: {
          paid: 'Order marked as paid successfully',
          cancel: 'Order canceled successfully',
          errorCancel: 'Failed to cancel the order',
          nf: 'Invoice saved successfully',
          errorNf: 'Failed to save the invoice',
        },
        kitMandatory: {
          success: 'Updated successfully.',
          error: 'Failed to update.',
        }
      },
      active: 'Active',
      inactive: 'Inactive',
      status: 'Status',
      balanceInsufficient: 'Insufficient stock',
      balance: 'In stock',
      create: {
        form: {
          button: 'Save',
          name: 'Kit name',
          image: 'Kit image',
          price: 'Minimum price',
          type: 'Kit type',
          types: {
            makeup: 'Makeup',
            input: 'Input',
          },
          custom: 'Customizable',
          active: 'Active',
          discount: 'Discount (%)',
          isExclusive: 'Exclusive',
          isGloballyAvailable: 'Available for all',
          isBasicKitRequired: 'Mandatory Kit',
          fixedItemsQuantity: 'Fixed quantity of items',
          units: {
            list: 'Units',
            search: 'Search units',
            period: 'Period',
            empty: 'No units added',
          },
          regions: {
            search: 'Search regions',
          },
          products: {
            list: 'Products',
            search: 'Search products',
            exception: '*Select the kit type before adding products',
            empty: 'No products added',
            min: 'Minimum quantity',
            max: 'Maximum quantity',
          },
        },
      },
    },
  },
  cart: {
    title: 'Shopping Cart',
    table: {
      name: 'Name',
      quantity: 'Quantity',
      unitValue: 'Unit Price',
      subtotal: 'Subtotal',
      total: 'Total',
      button: 'Next',
      continueShopping: 'Continue Shopping',
      discount: 'Discount',
      goldPoints: 'Gold Points',
      silverPoints: 'Silver Points',
    },
    info: {
      title: 'Boleto Due Date',
      description: 'Payments after the boleto due date will not be accepted. Please pay attention to the date printed on the boleto.',
    },
    notification: {
      remove: {
        error: 'Failed to remove the kit from the cart',
      },
      add: {
        error: 'Failed to add the kit to the cart',
        product: 'Please review the products listed below.',
      },
      update: {
        error: 'Failed to update the kit in the cart',
      },
    },
  },
  table: {
    of: 'of',
    items: 'items',
    perPage: ' per page',
    columnSearch: {
      search: 'Search',
      reset: 'Clear',
    },
  },
  modal: {
    kitProduct: {
      purchaseAvailable: 'Available in installments',
      purchaseLimitExceeded: 'The kit amount is above the balance available for installments. You can add it to the cart, but the order can only be paid upfront.',
      cashOnly: 'Upfront only',
      minimum: 'Minimum price',
      kitValue: 'Kit value',
      addToCart: 'Add to cart',
      updateCart: 'Update cart',
      pointsAvailable: 'Points available',
      fixedItemsQuantity: 'Required products',
    },
  },
  wallets: {
    addNew: 'Add',
    table: {
      wallet: 'Wallet',
      description: 'Description',
      unit: 'Unit',
      type: 'Type',
      points: 'Points',
      noAccess: 'Sorry, user does not have permission to access this page.',
      empty: 'No data',
      name: 'Name',
      isActive: 'Active?',
      product: 'Product',
      reward: 'Reward',
      rewardDescription: 'Points bonus of type {type}',
      quantity: 'Quantity',
      dateCreate: 'Creation date',
    },
    titleModal: 'Deposit points',
    form: {
      title: 'Title',
      product: 'Product',
      productName: 'Product name',
      unit: 'Unit',
      type: 'Type',
      quantity: 'Quantity',
      points: 'Points',
      description: 'Description',
      button: 'Submit',
      addNew: 'Add',
      message: {
        unit: 'Unit selection is required!',
        type: 'Wallet type selection is required!',
        product: 'Product selection is required!',
        productName: 'Product name is required!',
        tooltip: 'Select the product available for point exchange, enabled by FOCCO.',
        points: 'At least one point is required!',
        quantity: 'At least one quantity is required!',
        description: 'A description about this deposit is required!',
      },
      placeholder: {
        unit: 'Select a unit',
        product: 'Select a product',
        type: 'Select the wallet type',
      },
    },
    notification: {
      error: 'Could not load points.',
      create: {
        success: 'Deposit completed successfully.',
        error: 'Could not complete the deposit.',
      },
      product: {
        create: {
          success: 'Product successfully registered.',
          error: 'Error registering product.',
        },
        update: {
          success: 'Product updated successfully.',
          error: 'Error updating product.',
        },
      }
    },
  },
  promotions: {
    addNew: 'Add',
    save: 'Save',
    table: {
      promotion: 'Promotion',
      discount: 'Discount',
      startsAt: 'Start',
      finishesAt: 'End',
    },
    form: {
      title: 'Title',
      discount: 'Discount',
      startsAt: 'Start',
      finishesAt: 'End',
      button: 'Submit',
      period: 'Period',
      active: 'Active',
      description: 'Description',
      addNew: 'Add',
      rules: 'Rules',
      discountIsVariable: 'Variable Discount',
    },
    rules: {
      type: 'Type',
      operator: 'Operator',
      value: 'Value',
    },
    types: {
      kits: 'Kits',
      payments: 'Payment Methods',
      shipping: 'Shipping',
      subtotal: 'Subtotal',
      cart: 'Cart',
      unit: 'Unit',
      region: 'Region',
      purchasedKit: 'Kit already purchased by the unit',
      purchasedKitPayment: 'Payment method of the purchased kit',
    },
    operators: {
      equalTo: 'Equal to (==)',
      lessThan: 'Less than (<)',
      lessThanOrEqual: 'Less than or equal to (<=)',
      greaterThan: 'Greater than (>)',
      greaterThanOrEqual: 'Greater than or equal to (>=)',
      contain: 'Contains',
      notContain: 'Does not contain',
    },
    notification: {
      create: {
        success: 'Promotion created successfully.',
        error: 'Could not create the promotion.',
      },
      update: {
        success: 'Promotion updated successfully.',
        error: 'Could not update the promotion.',
      },
    }
  },
  financial: {
    addDefaulter: 'Add Defaulter',
    table: {
      unit: 'Unit',
      editUser: 'Edited User',
      createdAt: 'Created',
      updatedAt: 'Updated',
      kitMandatory: 'Mandatory Kit Released'
    },
    pleaseSelectedUnit: 'Please! Select the unit.',
    selectedUnit: 'Select the unit',
    createDefaulter: 'Add Defaulter',
    editDefaulter: 'Edit Defaulter',
    isActiveDefaulter: {
      true: 'Defaulter',
      false: 'Released'
    },
    addNoteCustomer: 'Add a note for this customer',
    addNote: 'Add a note',
    viewNoteFrom: 'View note from',
    tabs: {
      defaulters: 'Defaulters',
      purchaseLimit: 'Purchase limit',
      ordersProcessing: 'Orders in processing',
    },
    ordersProcessing: {
      orders: 'In processing',
      oldest: 'Oldest',
      kitTypes: 'Types',
      total: 'Amount',
      order: 'Order',
      orderedAt: 'Placed',
      empty: 'No unit with an order in processing',
      filter: {
        processing: 'With order in processing',
        all: 'All units',
      },
      status: {
        title: 'Status',
        none: 'No order',
        blocked: 'Blocked',
        released: 'Released',
      },
      stats: {
        units: 'Units with order in processing',
        orders: 'Orders in processing',
        released: 'Units allowed to buy',
      },
    },
    allowOrderWhileProcessing: {
      title: 'Buy with order in processing',
      help: 'When released, the unit can place new orders even with an order of the same type in Processing status.',
      released: 'Released',
      blocked: 'Blocked',
      confirm: 'Allow unit {unit} to buy even with an order in processing?',
      processing: 'Order in processing',
      processingBlocked: 'The unit has an order in processing and is blocked from buying kits of the same type.',
      processingReleased: 'The unit has an order in processing, but is allowed to keep buying.',
      notification: {
        success: 'Permission updated successfully.',
        error: 'Unable to update the permission.',
      },
    },
    purchaseLimit: {
      description: 'Maximum product amount (with discounts, without shipping and insurance) each unit can buy in installments. Monthly: adds up installment orders of the current month and the balance resets on the 1st of each month. Per period: adds up installment orders placed between the chosen dates (end date optional); outside the period installments are not limited. Paid orders still count; canceled orders do not. Upfront purchases have no limit. Leave empty for no limit.',
      perMonth: 'Monthly, installments only',
      type: {
        monthly: 'Monthly',
        period: 'Per period',
      },
      period: {
        from: 'From',
        to: 'to',
        startPlaceholder: 'Start date',
        endPlaceholder: 'No end date',
        range: 'From {from} to {to}',
        since: 'From {from} on',
        startRequired: 'Enter the period start date to save',
      },
      usage: {
        title: 'Usage',
        used: '{used} of {limit}',
        available: 'Available: {value}',
        help: 'Sum of installment orders placed in {month}. Canceled orders free up the balance; the balance resets at the start of each month.',
        helpPeriod: 'Sum of installment orders placed in the period ({period}). Canceled orders free up the balance.',
        inactiveHelp: 'Outside the period installments are not limited.',
        startsAt: 'Starts on {date}',
        endedAt: 'Ended on {date}',
      },
      limit: 'Installment limit',
      noLimit: 'No limit',
      placeholder: 'No limit',
      save: 'Save',
      clear: 'Remove limit',
      updatedBy: 'Changed by',
      updatedAt: 'Changed at',
      current: 'Current limit',
      unsaved: 'Unsaved change — press Enter to save, Esc to cancel',
      cancel: 'Cancel',
      confirm: 'Confirm',
      confirmZero: 'With a zero limit, unit {unit} will only be able to buy with upfront payment. Confirm?',
      confirmClear: 'Remove the installment limit of unit {unit}? It will be able to place installment orders of any amount.',
      notification: {
        success: 'Purchase limit updated successfully.',
        error: 'Unable to update the purchase limit.',
      },
    },
    notification: {
      create: {
        success: 'Defaulter added successfully.'
      }
    }
  },
}

export default {
  locale: 'US',
  label: 'English',
  country: 'US',
  currency: 'USD',
  dictionary,
}
